var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.4,
    height: 27.02,
    viewBox: "0 0 34.4 27.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10755",
    "data-name": "Group 10755",
    transform: "translate(-41.321 -527.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10706",
    "data-name": "Group 10706",
    transform: "translate(48.7 527.49)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14547",
    "data-name": "Rectangle 14547",
    width: 27.02,
    height: 27.02,
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7228",
    "data-name": "Path 7228",
    d: "M271.034,183v2.2c1.285.068,4.567-.2,5.074,1.387h-5.074v1.962h5.311a3.216,3.216,0,0,1-2.5,1.827l-2.808.068L271,192.4l5.886,6.833h3.045l-5.548-6.8a5,5,0,0,0,4.7-3.992l2.131.068v-1.861h-2.3a3.129,3.129,0,0,0-.643-1.725h3.011V183Z",
    transform: "translate(-263.704 -177.938)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-upload-2218267",
    transform: "translate(53.621 549.159) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10708",
    "data-name": "Group 10708",
    transform: "translate(0.73 2.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10707",
    "data-name": "Group 10707",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7230",
    "data-name": "Path 7230",
    d: "M.943,6.325l.485-.535L2.592,4.5,4,2.949,5.216,1.606c.2-.216.4-.429.59-.651L5.815.946H5.031l.485.535L6.679,2.766,8.087,4.321,9.3,5.664c.2.217.387.44.59.651l.009.009a.559.559,0,0,0,.785,0,.567.567,0,0,0,0-.785L10.2,5.005,9.038,3.719,7.63,2.165,6.415.822c-.2-.217-.387-.44-.59-.651L5.815.161a.558.558,0,0,0-.785,0L4.546.7,3.382,1.982,1.974,3.536.758,4.879c-.2.216-.4.431-.59.651L.158,5.54a.565.565,0,0,0,0,.785.562.562,0,0,0,.785,0Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10710",
    "data-name": "Group 10710",
    transform: "translate(5.595 2.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10709",
    "data-name": "Group 10709",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7231",
    "data-name": "Path 7231",
    d: "M0,.556V13.292c0,.174,0,.346,0,.52v.022a.562.562,0,0,0,.555.555.564.564,0,0,0,.555-.555V1.1c0-.174,0-.346,0-.52V.556A.562.562,0,0,0,.556,0,.565.565,0,0,0,0,.556Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10712",
    "data-name": "Group 10712",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10711",
    "data-name": "Group 10711",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7232",
    "data-name": "Path 7232",
    d: "M.556,1.114h9.813c.452,0,.9.007,1.358,0h.019A.562.562,0,0,0,12.3.558.564.564,0,0,0,11.745,0H1.932C1.481,0,1.027,0,.574,0H.556A.562.562,0,0,0,0,.558a.565.565,0,0,0,.555.555Z",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/Delivery.839c060d5fc482e97e8e5098eceea714.svg";
export { ForwardRef as ReactComponent };